@let loadedAccessGroup = accessGroup$ | async;

<h2 mat-dialog-title>
  <mat-icon svgIcon="security"></mat-icon>
  <!-- <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg> -->
  Adgangsbegrænsninger for adgangsgruppen {{ accessGroup()?.name }}
</h2>
<button type="button" class="btn-close btn-icon" (click)="close()">
  <mat-icon>close</mat-icon>
</button>

@if (loadedAccessGroup) {
  <mat-dialog-content>
    <adm-access-group-customer-number-management
      #customerNumberManagement
      [accessGroupIdentifier]="accessGroup()?.identifier ?? ''"
      [saving]="saving()"
      (saveCustomerNumbers)="handleSaveCustomerNumbers($event)" />
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-button (click)="close()">Luk</button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      [disabled]="saving() || !customerNumberManagement.hasChanges()"
      (click)="customerNumberManagement.emitSaveCustomerNumbers()">
      Gem
    </button>
  </mat-dialog-actions>
}
